module.exports = __webpack_public_path__ + "img/PEAR.e0d7171c.png";